import React, {Fragment} from 'react';
import {TextField} from 'material-ui';
import Checkbox from './../Checkbox';
import Select from './../Select';
import Tooltips from './../Tooltips';
import ElementProperties from './ElementProperties';

export default (props) => {
	let {isScreen, isGroup} = props.experiment.getViewStateFromCurrentScreen();
	let RightPane = NoProperties;
	if(isGroup){ RightPane = GroupProperties; }
	if(isScreen){ RightPane = ScreenProperties; }
	return (
		<RightPane screen={props.screen} experiment={props.experiment} />
	);
}

const CREATE_NEW_DATASET = '( create new data set )';

const NoProperties = () => {
	return (
		<Fragment>
			<div className="Builder-right-rail-title"> PROPERTIES (N/A)</div>
		</Fragment>
	);
}

const ScreenProperties = ({screen, experiment}) => {
	let parentAutoAdvance = experiment.getScreenParent(screen).autoAdvance;
	return (
		<Fragment>
			<div className="Builder-right-rail-title">SCREEN PROPERTIES</div>

			<TextField
				label={<span>ID <Tooltips id="id" /></span>}
				id="screen-id-input"
				value={screen.id || ''}
				onChange={ e => { screen.id = e.currentTarget.value; experiment.forceUpdate(); } }
				margin="normal"
				InputLabelProps={{ shrink: true }}
				fullWidth/>

			<TextField
				label={<span>AUTO-ADVANCE (SECONDS) <Tooltips id="autoAdvance" /></span>}
				id="screen-auto-advance-input"
				value={screen.autoAdvance || ''}
				onChange={ e => { screen.autoAdvance = e.currentTarget.value; experiment.forceUpdate(); } }
				margin="normal"
				placeholder={!!parentAutoAdvance ? `${parentAutoAdvance} (from parent group)` : ''}
				InputLabelProps={{ shrink: true }}
				helperText={!!parentAutoAdvance ? `Enter "0" to prevent advancing` : ''}
				fullWidth/>
				

			<div className="Builder-right-rail-title" style={{marginTop:'30px'}}>ELEMENT PROPERTIES</div>
			<ElementProperties experiment={experiment} />

		</Fragment>
	);
}

const GroupProperties = ({screen, experiment}) => {
	return (
		<Fragment>
			<div className="Builder-right-rail-title">GROUP PROPERTIES</div>
			
			<style dangerouslySetInnerHTML={{__html: `
				.MediaManager-drag-input, .MediaManager-drag-bg { display:none !important; }
			`}} />
			

			<TextField
				label={<span>ID <Tooltips id="id" /></span>}
				id="screen-id-input"
				value={screen.id || ''}
				onChange={ e => { screen.id = e.currentTarget.value; experiment.forceUpdate(); } }
				margin="normal"
				InputLabelProps={{ shrink: true }}
				fullWidth/>

			<TextField
				label="AUTO-ADVANCE CHILDREN (SECONDS)"
				id="screen-auto-advance-input"
				value={screen.autoAdvance || ''}
				onChange={ e => { screen.autoAdvance = e.currentTarget.value; experiment.forceUpdate(); } }
				margin="normal"
				InputLabelProps={{ shrink: true, style:{width:'300px'} }}
				fullWidth/>

			{screen === experiment.data.screens &&
			<TextField
				label="OVERALL TIME LIMIT (MINUTES)"
				value={screen.overallTimeLimit || ''}
				onChange={ e => { screen.overallTimeLimit = e.currentTarget.value; experiment.forceUpdate(); } }
				margin="normal"
				InputLabelProps={{ shrink: true, style:{width:'300px'} }}
				fullWidth/>
			}

			<Checkbox
				label={<span>Randomize children <Tooltips id="randomizeChildren" /></span>}
				checked={!!screen.randomizeChildren}
				onChange={ e => { screen.randomizeChildren = e.currentTarget.checked; experiment.forceUpdate(); } }
			/>
			

			<Checkbox
				label={<span>Use a dataset <Tooltips id="dataset" /></span>}
				checked={!!screen.useDataSet}
				onChange={ e => { screen.useDataSet = e.currentTarget.checked; experiment.forceUpdate(); } }
			/>

			{!!screen.useDataSet &&
			<div style={{borderLeft:'solid 5px #e2e2e2', paddingLeft:'10px'}}>
				
				<Select
					label='Dataset Id'
					value={screen.dataSetId}
					onChange={ value =>{ 
						if( value === CREATE_NEW_DATASET ){
							let id = 'Dataset #' + (experiment.data.dataSets.length + 1);
							value = id;
							experiment.data.dataSets.push({id, rows:[
								['id','column_1','column_2'],
								[1,'',''],
								[2,'',''],
								[3,'',''],
							]});
						}
						screen.dataSetId = value; 
						experiment.forceUpdate(); 
					} }
					options={ ['', ...experiment.dataSetIds, CREATE_NEW_DATASET]}
					newRow
					fullwidth
					margin={'normal'}
					/>
				
				<TextField
					label="NUMBER OF ROWS TO USE"
					id="screen-row-limit"
					value={screen.dataSetRowLimit || ''}
					onChange={ e => { screen.dataSetRowLimit = e.currentTarget.value; experiment.forceUpdate(); } }
					margin="normal"
					placeholder="Use all rows in dataset"
					InputLabelProps={{ shrink: true }}
					fullWidth/>

				<Checkbox
					label="Randomize rows"
					checked={!!screen.randomizeDataSet}
					onChange={ e => { screen.randomizeDataSet = e.currentTarget.checked; experiment.forceUpdate(); } }
				/>
			</div>
			}




		</Fragment>
	);
}


// WEBPACK FOOTER //
// ./src/components/Builder/ExperimentRightRail.js